import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-update-address',
  templateUrl: './update-address.component.html',
  styleUrls: ['./update-address.component.scss']
})
export class UpdateAddressComponent implements OnInit {
  id: any;
  model = {
    firstName: '',
    lastName: '',
    address: '',
    postalCode: '',
    number: '',
    city: '',
    userId: '',
    email: '',
    userRewardId: ''
  };


  constructor(private route: ActivatedRoute, private coreService: CoreService, private router: Router, private readonly authService: AuthService) {
    this.route.params.subscribe((params: any) => {
      console.log('params', params);
      this.id = params.id;
    });
  }

  ngOnInit() {
    if (this.id) {
      this.getAddressDetails();
    } else {
      this.router.navigate(['/']);
    }
  }

  getAddressDetails() {
    this.coreService.getAddressDetails(this.id).then((response: any) => {
      console.log('getAddress', response);
      const address = response.result.userRewardRecipientAddress;
      this.model.firstName = address.firstName;
      this.model.lastName = address.lastName;
      this.model.address = address.address;
      this.model.postalCode = address.postalCode;
      this.model.number = address.number;
      this.model.city = address.city;
      this.model.userId = address.userId;
      this.model.email = address.email;
      this.model.userRewardId = address.userRewardId;
    });
  }

  onSubmit() {
    const body = {
      FirstName: this.model.firstName,
      LastName: this.model.lastName,
      Address: this.model.address,
      PostalCode: this.model.postalCode,
      Number: this.model.number,
      City: this.model.city,
      UserId: this.model.userId,
      Email: this.model.email,
      UserRewardId: this.model.userRewardId,
    };
    this.coreService.updateAddress(body).then((response: any) => {
      console.log('onSubmit', response);
      if (response.messageKey === 'address-updated') {
        this.router.navigate(['updateSuccess']);
        return;
      }
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
